import { useEffect, useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../_metronic/_partials/controls";
import { LeadsTable } from "./leads-table/LeadsTable";
import { useLeadsUIContext } from "./LeadsUIContext";
import { useIntl } from "react-intl";
import { useSubheader } from "../../../../../_metronic/layout";
import { Filter } from "../../../../_components/Filter";
import { shallowEqual, useSelector } from "react-redux";
import { canCreate, canReadAll } from "../../../../_utils/authUtils";
import ActionNewButton from "app/_components/ActionNewButton";

export function LeadsCard() {
  const intl = useIntl();
  const leadsUIContext = useLeadsUIContext();
  const leadsUIProps = useMemo(() => {
    return {
      ids: leadsUIContext.ids,
      queryParams: leadsUIContext.queryParams,
      setQueryParams: leadsUIContext.setQueryParams,
      newLeadButtonClick: leadsUIContext.newLeadButtonClick,
      openDeleteLeadsDialog: leadsUIContext.openDeleteLeadsDialog,
      openUpdateLeadsStatusDialog: leadsUIContext.openUpdateLeadsStatusDialog,
      openFetchLeadsDialog: leadsUIContext.openFetchLeadsDialog,
    };
  }, [leadsUIContext]);

  const subheader = useSubheader();
  useEffect(() => {
    subheader.setTitle(
      intl.formatMessage({
        id: "LEAD.TITLE",
      })
    );
  }, [subheader]);
  const { groups, session } = useSelector(
    (state) => ({
      groups: state.auth.groups,
      session: state.auth.session,
    }),
    shallowEqual
  );
  return (
    <Card>
      <CardHeader
        title={intl.formatMessage({
          id: "LEAD.TITLE.LIST",
        })}
      >
        <CardHeaderToolbar>
          {canCreate(groups, session, "LEAD") && canReadAll(groups, session, "CLIENT") && (
            <ActionNewButton
              dataCy="button-new-lead"
              onClick={leadsUIProps.newLeadButtonClick}
              messageId="LEAD.ACTION.NEW"
            />
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Filter useEntityUIContext={useLeadsUIContext} />
        <LeadsTable />
      </CardBody>
    </Card>
  );
}
